/* eslint-disable import/prefer-default-export */
import Immutable from 'seamless-immutable';
import moment from 'moment';
import _ from 'lodash';

import { reducerName, createActionName } from './naming';
import * as types from './actionsTypes';
import {
  createValidateObject,
  createField,
  createFieldFromArr,
  createFieldsArr,
  createFieldsObj,
  createFieldManual,
  addToFieldsArr,
  dropToFieldsArr,
  changeFieldByPath,
  storeRecoveryFieldValues,
  storeFieldsValidate,
  storeSetFieldValue,
  storeSetFieldsErrors
} from '../../../../../utils/reducerHalpers/formFields';
import * as validateTypes from '../../../../../utils/reducerHalpers/validateTypes';
import {
  dropElByKeyMaskFromObj,
  dropElByIdxFromArr
} from '../../../../../utils/imutableHalpers';
import {
  createRequestStates,
  setRequestStateFinish,
  setRequestStateInProgress
} from '../../../../../utils/reducerHalpers/requestState';

import { tWind } from '../../../../../../utils/translates';

const createCommentFormReducer = name => {
  function stateDefault() {
    return {
      ...createRequestStates(['send', 'recovery']),
      hasRecoveredFields: false,
      counterSuccessSaved: 0,
      fields: {
        ...createField({
          field: 'title',
          title: 'Название задачи',
          value: '',
          validate: [createValidateObject(validateTypes.REQUIRED)]
        }),
        ...createField({
          field: 'type_id',
          title: 'Тип задачи',
          value: null,
          validate: [createValidateObject(validateTypes.REQUIRED)]
        }),
        ...createField({
          field: 'locale_code',
          title: 'Язык',
          value: 'ru',
          validate: [createValidateObject(validateTypes.REQUIRED)]
        }),
        ...createField({
          field: 'cost_execution',
          title: 'Стоимость выполнения',
          value: '',
          validate: [createValidateObject(validateTypes.REQUIRED)]
        }),
        ...createField({
          field: 'max_executions',
          title: 'Кол-во выполнений',
          value: '',
          validate: [createValidateObject(validateTypes.REQUIRED)]
        }),
        ...createField({
          field: 'desc',
          title: 'Описание задания',
          value: tWind('create_task_form-desc-template'),
          validate: [createValidateObject(validateTypes.REQUIRED)]
        }),
        ...createField({
          field: 'check_type',
          title: 'Тип проверки',
          value: '1',
          validate: [createValidateObject(validateTypes.REQUIRED)]
        }),
        ...createField({
          field: 'links',
          title: 'Ссылки',
          value: [''],
          validate: [createValidateObject(validateTypes.REQUIRED)]
        }),
        ...createField({
          field: 'random_link',
          title: 'Переход по ссылкам',
          value: '0',
          validate: [createValidateObject(validateTypes.REQUIRED)]
        }),
        ...createField({
          field: 'adult_content',
          title: 'Для взрослых',
          value: '0',
          validate: [createValidateObject(validateTypes.REQUIRED)]
        }),
        ...createField({
          field: 'software_install',
          title: 'Установка ПО, Опасность',
          value: '0',
          validate: [createValidateObject(validateTypes.REQUIRED)]
        }),
        ...createField({
          field: 'time_checking',
          title: 'Время на проверку задания',
          value: '1440',
          validate: [createValidateObject(validateTypes.REQUIRED)]
        }),
        ...createField({
          field: 'time_perform',
          title: 'Время на выполнение',
          value: '60',
          validate: [createValidateObject(validateTypes.REQUIRED)]
        }),
        ...createField({
          field: 'executor_execution_interval',
          title: 'Многоразовость выполнения для 1 пользователя',
          value: null,
          validate: [createValidateObject(validateTypes.REQUIRED)]
        }),
        ...createField({
          field: 'executor_execution_interval_check',
          title: 'Выполнение до проверки',
          value: '0',
          validate: [createValidateObject(validateTypes.REQUIRED)]
        }),
        ...createField({
          field: 'check_desc',
          title: 'Информация для подтверждения',
          value: tWind('create_task_form-check-desc-template'),
          validate: [createValidateObject(validateTypes.REQUIRED)]
        }),
        ...createField({
          field: 'require_link_in_report',
          title: 'Требовать ссылку в отчете',
          value: 0,
          validate: [createValidateObject(validateTypes.REQUIRED)]
        }),
        ...createField({
          field: 'require_screenshot_in_report',
          title: 'Требовать скриншот в отчете',
          value: 0,
          validate: [createValidateObject(validateTypes.REQUIRED)]
        }),
        ...createField({
          field: 'p_executor_email_confirm',
          title: 'Подтвержденный E-mail',
          value: '0',
          validate: [createValidateObject(validateTypes.REQUIRED)]
        }),
        ...createField({
          field: 'p_hide_for_black_list',
          title: 'Не показывать пользователям из черного списка',
          value: '1',
          validate: [createValidateObject(validateTypes.REQUIRED)]
        }),
        ...createField({
          field: 'p_executor_min_rating',
          title: 'Рейтинг исполнителя не ниже',
          value: '',
          validate: [createValidateObject(validateTypes.REQUIRED)]
        }),
        ...createField({
          field: 'quiz',
          title: 'Вопросы и ответы',
          value: [{ ask: '', answer: [''] }],
          validate: [createValidateObject(validateTypes.REQUIRED)]
        }),
        ...createFieldsArr({
          field: 'time_target',
          title: 'Таргетинг по времени',
          value: [],
          validate: []
        }),
        ...createFieldManual({
          field: 'geo_target',
          title: 'Геотаргетинг',
          value: {
            typeComparison: null,
            countries: {}
          },
          converterValueToSend: value => {
            const result = [];
            if (value.typeComparison === null) {
              return [];
            }
            Object.keys(value.countries).map(countryId => {
              result.push({
                type_comparison: value.typeComparison,
                country_iso_code: countryId
              });
              const country = value.countries[countryId];
              if (
                !_.isEmpty(country.regions) &&
                country.typeComparison !== null
              ) {
                Object.keys(country.regions).map(regionId => {
                  result.push({
                    type_comparison: country.typeComparison,
                    country_iso_code: countryId,
                    region_iso_code: regionId
                  });
                  const region = country.regions[regionId];
                  if (
                    !_.isEmpty(region.cities) &&
                    region.typeComparison !== null
                  ) {
                    Object.keys(region.cities).map(citiId => {
                      result.push({
                        type_comparison: region.typeComparison,
                        country_iso_code: countryId,
                        region_iso_code: regionId,
                        city_iso_code: citiId
                      });
                      return null;
                    });
                  }
                  return null;
                });
              }
              return null;
            });
            return result;
          },
          validate: []
        })
      },
      errors: {},
      resultObject: {}
    };
  }

  /**
   * Хелперы для управления полем таймтаргетинга
   */
  // Создает объект дней недели
  const createWeekdaysField = value =>
    createField({
      field: 'weekdays',
      title: 'Дни недели',
      value,
      validate: []
    });

  // Создает объект массива периодов
  const createTimesFieldsArr = value =>
    createFieldsArr({
      field: 'times',
      title: 'Время',
      value,
      validate: []
    });

  // Создает объект периода
  const createTimeTargetItemFieldFromArr = value =>
    createFieldFromArr({
      field: 'timeRange',
      title: 'Диапазон времени',
      value,
      validate: [
        (state, field) => {
          const from = moment(field.value.time_from, 'HH:mm');
          const to = moment(field.value.time_to, 'HH:mm');
          if (from > to) {
            return `Неправильный диапазон`;
          }
          return null;
        }
      ]
    });

  // Восстановление таймтаргетинга из ответа
  const recoveryTimeTarget = data => {
    const result = [];
    data.map(item => {
      const times = [];
      item.times.map(itemTimeRange => {
        times.push(createTimeTargetItemFieldFromArr(itemTimeRange));
        return null;
      });
      const weekDaysValueItem = createFieldsObj({
        value: {
          ...createWeekdaysField(item.weekdays),
          ...createTimesFieldsArr(times)
        }
      });
      result.push(weekDaysValueItem);
      return null;
    });
    return result;
  };

  // Восстановление геотаргетинга из ответа
  const recoveryGeoTarget = data => {
    const result = {
      typeComparison: null,
      countries: {}
    };
    if (!_.isEmpty(data)) {
      result.typeComparison = data.type_comparison.toString();
      if (!_.isEmpty(data.countries)) {
        const countries = {};
        Object.keys(data.countries).map(countryId => {
          const country = data.countries[countryId];
          const regions = {};
          if (!_.isEmpty(country.regions)) {
            Object.keys(country.regions).map(regionId => {
              const region = country.regions[regionId];
              const cities = {};
              if (!_.isEmpty(region.cities)) {
                Object.keys(region.cities).map(cityId => {
                  cities[cityId] = null;
                  return null;
                });
              }
              regions[regionId] = {
                typeComparison:
                  region.type_comparison !== null &&
                  region.type_comparison !== undefined
                    ? region.type_comparison.toString()
                    : null,
                cities
              };
              return null;
            });
          }
          countries[countryId] = {
            typeComparison:
              country.type_comparison !== null &&
              country.type_comparison !== undefined
                ? country.type_comparison.toString()
                : null,
            regions
          };
          return null;
        });
        result.countries = countries;
      }
    }
    return result;
  };

  const initialState = Immutable(stateDefault());
  return function reduce(state = initialState, action = {}) {
    switch (action.type) {
      case createActionName(name, types.INIT_STATE):
        return Immutable(stateDefault());
      case createActionName(name, types.REQUEST_RECOVERY_FORM):
        return setRequestStateInProgress(state, 'recovery');
      case createActionName(name, types.RECOVERY_FORM_FIELDS):
        return storeRecoveryFieldValues(state, action.payload, {
          time_target: recoveryTimeTarget,
          geo_target: recoveryGeoTarget
        });
      case createActionName(name, types.SEND_FORM):
        return setRequestStateInProgress(state, 'send');
      case createActionName(name, types.VALIDATE):
        return storeFieldsValidate(state);
      case createActionName(name, types.SET_ERRORS):
        return storeSetFieldsErrors(state, action.payload);
      case createActionName(name, types.CLEAR_ALL_ERRORS):
        return state.merge({
          errors: {}
        });
      case createActionName(name, types.FINISHED_SEND_REQUEST):
        return setRequestStateFinish(
          state,
          action.payload.codeResponse,
          action.payload.hasSuccess,
          'send'
        );
      case createActionName(name, types.FINISHED_RECOVERY_REQUEST):
        return setRequestStateFinish(
          state,
          action.payload.codeResponse,
          action.payload.hasSuccess,
          'recovery'
        );
      case createActionName(name, types.SET_SEND_FORM_RESPONSE):
        return state.merge({
          resultObject: action.payload,
          counterSuccessSaved: state.counterSuccessSaved + 1
        });

      // FIELDS
      case createActionName(name, types.CHANGE_FIELD_TITLE): {
        return storeSetFieldValue(state, 'title', action.payload);
      }
      case createActionName(name, types.CHANGE_FIELD_TYPE_ID): {
        return storeSetFieldValue(state, 'type_id', action.payload);
      }
      case createActionName(name, types.CHANGE_FIELD_LOCALE_CODE): {
        return storeSetFieldValue(state, 'locale_code', action.payload);
      }
      case createActionName(name, types.CHANGE_FIELD_COST_EXECUTION): {
        return storeSetFieldValue(state, 'cost_execution', action.payload);
      }
      case createActionName(name, types.CHANGE_FIELD_MAX_EXECUTIONS): {
        return storeSetFieldValue(state, 'max_executions', action.payload);
      }
      case createActionName(name, types.CHANGE_FIELD_DESC): {
        return storeSetFieldValue(state, 'desc', action.payload);
      }
      case createActionName(name, types.CHANGE_FIELD_CHECK_TYPE): {
        return storeSetFieldValue(state, 'check_type', action.payload);
      }
      case createActionName(name, types.CHANGE_FIELD_RANDOM_LINK): {
        return storeSetFieldValue(state, 'random_link', action.payload);
      }
      case createActionName(name, types.CHANGE_FIELD_ADULT_CONTENT): {
        return storeSetFieldValue(state, 'adult_content', action.payload);
      }
      case createActionName(name, types.CHANGE_FIELD_SOFTWARE_INSTALL): {
        return storeSetFieldValue(state, 'software_install', action.payload);
      }
      case createActionName(name, types.CHANGE_FIELD_TIME_CHECKING): {
        return storeSetFieldValue(state, 'time_checking', action.payload);
      }
      case createActionName(name, types.CHANGE_FIELD_TIME_PERFORM): {
        return storeSetFieldValue(state, 'time_perform', action.payload);
      }
      case createActionName(
        name,
        types.CHANGE_FIELD_P_EXECUTOR_EMAIL_CONFIRM
      ): {
        return storeSetFieldValue(
          state,
          'p_executor_email_confirm',
          action.payload
        );
      }
      case createActionName(name, types.CHANGE_FIELD_P_HIDE_FOR_BLACK_LIST): {
        return storeSetFieldValue(
          state,
          'p_hide_for_black_list',
          action.payload
        );
      }
      case createActionName(name, types.CHANGE_FIELD_P_EXECUTOR_MIN_RATING): {
        return storeSetFieldValue(
          state,
          'p_executor_min_rating',
          action.payload
        );
      }
      case createActionName(
        name,
        types.CHANGE_FIELD_EXECUTOR_EXECUTION_INTERVAL
      ): {
        return storeSetFieldValue(
          state,
          'executor_execution_interval',
          action.payload
        );
      }
      case createActionName(
        name,
        types.CHANGE_FIELD_EXECUTOR_EXECUTION_INTERVAL_CHECK
      ): {
        return storeSetFieldValue(
          state,
          'executor_execution_interval_check',
          action.payload
        );
      }
      case createActionName(name, types.CHANGE_FIELD_CHECK_DESC): {
        return storeSetFieldValue(state, 'check_desc', action.payload);
      }
      case createActionName(name, types.CHANGE_FIELD_REQUIRE_LINK_IN_REPORT): {
        return storeSetFieldValue(
          state,
          'require_link_in_report',
          action.payload
        );
      }
      case createActionName(
        name,
        types.CHANGE_FIELD_REQUIRE_SCREENSHOT_IN_REPORT
      ): {
        return storeSetFieldValue(
          state,
          'require_screenshot_in_report',
          action.payload
        );
      }
      /**
       * Дейтвия управления ссылками задания
       * */
      case createActionName(name, types.CHANGE_FIELD_LINKS): {
        return storeSetFieldValue(state, 'links', action.payload);
      }
      case createActionName(name, types.CLEAR_LINK_ERROR_BY_KEY): {
        const newErrors = { ...state.errors };
        delete newErrors[`links_${action.payload}`];
        return state.merge({ errors: newErrors });
      }

      /**
       * Дейтвия управления викториной автоматической проверки задания
       * */
      case createActionName(name, types.CHANGE_FIELD_QUIZ_ADD_ASK): {
        const newQuizValue = state.fields.quiz.value.concat([
          { ask: '', answer: [''] }
        ]);
        return state.merge(
          { fields: { quiz: { value: newQuizValue } } },
          { deep: true }
        );
      }
      case createActionName(name, types.CHANGE_FIELD_QUIZ_DELETE_ASK): {
        const newQuizValue = dropElByIdxFromArr(
          state.fields.quiz.value,
          action.payload
        );
        const newErrors = dropElByKeyMaskFromObj(state.errors, `quiz_`, true);

        return state
          .merge({ fields: { quiz: { value: newQuizValue } } }, { deep: true })
          .merge({ errors: newErrors });
      }
      case createActionName(name, types.CHANGE_FIELD_QUIZ_CHANGE_ASK): {
        const newValues = Immutable.asMutable(state.fields.quiz.value, {
          deep: true
        });
        newValues[action.payload.keyAsk].ask = action.payload.value;

        const newErrors = dropElByKeyMaskFromObj(
          state.errors,
          `quiz_${action.payload.keyAsk}`
        );

        return state
          .merge({ fields: { quiz: { value: newValues } } }, { deep: true })
          .merge({ errors: newErrors });
      }
      case createActionName(name, types.CHANGE_FIELD_QUIZ_ADD_ANSWER): {
        const newValues = Immutable.asMutable(state.fields.quiz.value, {
          deep: true
        });
        newValues[action.payload.keyAsk].answer = newValues[
          action.payload.keyAsk
        ].answer.concat(['']);
        return state.merge(
          { fields: { quiz: { value: newValues } } },
          { deep: true }
        );
      }
      case createActionName(name, types.CHANGE_FIELD_QUIZ_DELETE_ANSWER): {
        const newValues = Immutable.asMutable(state.fields.quiz.value, {
          deep: true
        });

        newValues[action.payload.keyAsk].answer = newValues[
          action.payload.keyAsk
        ].answer.filter((v, k) => k !== action.payload.keyAnswer);

        const newErrors = dropElByKeyMaskFromObj(
          state.errors,
          `quiz_${action.payload.keyAsk}_`,
          true
        );

        return state
          .merge({ fields: { quiz: { value: newValues } } }, { deep: true })
          .merge({ errors: newErrors });
      }
      case createActionName(name, types.CHANGE_FIELD_QUIZ_CHANGE_ANSWER): {
        const newValues = Immutable.asMutable(state.fields.quiz.value, {
          deep: true
        });
        newValues[action.payload.keyAsk].answer[action.payload.keyAnswer] =
          action.payload.value;

        const newErrors = dropElByKeyMaskFromObj(
          state.errors,
          `quiz_${action.payload.keyAsk}_${action.payload.keyAnswer}`
        );

        return state
          .merge({ fields: { quiz: { value: newValues } } }, { deep: true })
          .merge({ errors: newErrors });
      }

      /**
       * Действия управления таймтаргетингом
       * */
      case createActionName(
        name,
        types.CHANGE_FIELD_TIME_TARGET_ADD_WEEKDAYS
      ): {
        // По умолчанию выбираем все дни. Далее исключаем все дни которые уже выбраны
        let defaultWeekdays = [0, 1, 2, 3, 4, 5, 6];
        state.fields.time_target.value.map(item => {
          item.value.weekdays.value.map(weekday => {
            defaultWeekdays = defaultWeekdays.filter(
              value => value !== weekday
            );
            return null;
          });
          return null;
        });
        return addToFieldsArr(
          state,
          ['fields', 'time_target'],
          createFieldsObj({
            value: {
              ...createWeekdaysField(defaultWeekdays),
              ...createTimesFieldsArr([
                createTimeTargetItemFieldFromArr({
                  time_from: '00:00',
                  time_to: '23:59',
                  max_amount: null
                })
              ])
            }
          })
        );
      }
      case createActionName(
        name,
        types.CHANGE_FIELD_TIME_TARGET_DELETE_WEEKDAYS
      ): {
        return dropToFieldsArr(
          state,
          ['fields', 'time_target'],
          action.payload
        );
      }
      case createActionName(
        name,
        types.CHANGE_FIELD_TIME_TARGET_CHANGE_WEEKDAYS
      ): {
        const mutableValue = Immutable.asMutable(
          state.fields.time_target.value,
          { deep: true }
        );
        const newTimeTarget = mutableValue.map((item, index) => {
          const newValue = item;
          if (index === action.payload.blockIdx) {
            if (
              item.value.weekdays.value.indexOf(action.payload.weekday) !== -1
            ) {
              newValue.value.weekdays.value = item.value.weekdays.value.filter(
                e => e !== action.payload.weekday
              );
            } else {
              newValue.value.weekdays.value = newValue.value.weekdays.value.concat(
                action.payload.weekday
              );
            }
          } else {
            newValue.value.weekdays.value = item.value.weekdays.value.filter(
              e => e !== action.payload.weekday
            );
          }
          return newValue;
        });
        return state.merge(
          { fields: { time_target: { value: newTimeTarget } } },
          { deep: true }
        );
      }
      case createActionName(
        name,
        types.CHANGE_FIELD_TIME_TARGET_ADD_TIME_RANGE
      ): {
        return addToFieldsArr(
          state,
          [
            'fields',
            'time_target',
            'value',
            action.payload.weekDaysIndex,
            'value',
            'times'
          ],
          createTimeTargetItemFieldFromArr({
            time_from: '00:00',
            time_to: '23:59',
            max_amount: null
          })
        );
      }
      case createActionName(
        name,
        types.CHANGE_FIELD_TIME_TARGET_DELETE_TIME_RANGE
      ): {
        return dropToFieldsArr(
          state,
          [
            'fields',
            'time_target',
            'value',
            action.payload.weekDaysIndex,
            'value',
            'times'
          ],
          action.payload.timeRangeIndex
        );
      }
      case createActionName(
        name,
        types.CHANGE_FIELD_TIME_TARGET_CHANGE_TIME_RANGE_FROM
      ): {
        return changeFieldByPath(
          state,
          [
            'fields',
            'time_target',
            'value',
            action.payload.weekDaysIndex,
            'value',
            'times',
            'value',
            action.payload.timeRangeIndex
          ],
          { errors: [], value: { time_from: action.payload.timeFrom } }
        );
      }
      case createActionName(
        name,
        types.CHANGE_FIELD_TIME_TARGET_CHANGE_TIME_RANGE_TO
      ): {
        return changeFieldByPath(
          state,
          [
            'fields',
            'time_target',
            'value',
            action.payload.weekDaysIndex,
            'value',
            'times',
            'value',
            action.payload.timeRangeIndex
          ],
          { errors: [], value: { time_to: action.payload.timeTo } }
        );
      }

      case createActionName(
        name,
        types.CHANGE_FIELD_TIME_TARGET_CHANGE_TIME_MAX_AMOUNT
      ): {
        return changeFieldByPath(
          state,
          [
            'fields',
            'time_target',
            'value',
            action.payload.weekDaysIndex,
            'value',
            'times',
            'value',
            action.payload.timeRangeIndex
          ],
          { errors: [], value: { max_amount: action.payload.maxAmount } }
        );
      }

      case createActionName(name, types.CHANGE_FIELD_GEO_TARGET_TOGGLE_ITEM): {
        let arrPathToObject = [];
        let code = '';
        let itemValue = '';
        if (action.payload.countryIsoCode) {
          if (action.payload.regionIsoCode) {
            if (action.payload.cityIsoCode) {
              arrPathToObject = [
                'fields',
                'geo_target',
                'value',
                'countries',
                action.payload.countryIsoCode,
                'regions',
                action.payload.regionIsoCode,
                'cities'
              ];
              code = action.payload.cityIsoCode;
              itemValue = null;
            } else {
              arrPathToObject = [
                'fields',
                'geo_target',
                'value',
                'countries',
                action.payload.countryIsoCode,
                'regions'
              ];
              code = action.payload.regionIsoCode;
              itemValue = {
                typeComparison: null,
                cities: {}
              };
            }
          } else {
            arrPathToObject = ['fields', 'geo_target', 'value', 'countries'];
            code = action.payload.countryIsoCode;
            itemValue = {
              typeComparison: null,
              regions: {}
            };
          }
        } else {
          return state;
        }

        const object = Immutable.asMutable(_.get(state, arrPathToObject), {
          deep: true
        });
        if (code in object) {
          delete object[code];
        } else {
          object[code] = itemValue;
        }
        return Immutable.setIn(state, arrPathToObject, object);
      }
      case createActionName(
        name,
        types.CHANGE_FIELD_GEO_TARGET_CHANGE_TYPE_COMPARISON
      ): {
        let arrPathToObject = [];
        if (action.payload.countryIsoCodeRegions) {
          if (action.payload.regionIsoCodeCities) {
            arrPathToObject = [
              'fields',
              'geo_target',
              'value',
              'countries',
              action.payload.countryIsoCodeRegions,
              'regions',
              action.payload.regionIsoCodeCities
            ];
          } else {
            arrPathToObject = [
              'fields',
              'geo_target',
              'value',
              'countries',
              action.payload.countryIsoCodeRegions
            ];
          }
        } else {
          arrPathToObject = ['fields', 'geo_target', 'value'];
        }
        return changeFieldByPath(state, arrPathToObject, {
          typeComparison: action.payload.typeComparison
        });
      }

      default:
        return state;
    }
  };
};

export function createReduceObject(parentName) {
  const reduceObject = {};
  reduceObject[reducerName] = createCommentFormReducer(parentName);
  return reduceObject;
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/tasks/reducers/dynamic/taskFrom/reducer.js